module.exports = function ($stateParams, BreakpointsService, productGroupService, $state, $rootScope) {
  return {
    restrict: 'E',
      link(scope) {
          let isLoading = true;
          scope.groupId = $stateParams.Id;
          scope.productGroupService = productGroupService;
          scope.isSmallFormat = BreakpointsService.isSmallFormat();
          scope.$state = $state;

          scope.isPageLoading = function () {
              return isLoading;
          };

          $rootScope.$on('window:resize', function () {
                scope.$apply(function () {
                    scope.isSmallFormat = BreakpointsService.isSmallFormat();
                });
          });

          isLoading = false;
    },
    template: require('./product-group-page-template.html')
  };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/productgroup/product-group-page-directive.js
 **/